/**
 * Late header menus (header v4). The page ships only the row of department words; this fetches the
 * drop-down panels (computers) and the phone menu from sections/ri-header-menus.liquid, rendered for this
 * same address so the "you are here" marks are the same as when they were printed with the page.
 *
 * - Loads when the browser is idle after the page has loaded, or sooner when a menu is reached for
 *   (pointer over or focus in the department row, a press on the phone menu button, or ri-hv4.js asking).
 * - A phone menu tap that lands before the menu has arrived waits for it, then opens, so the sheet never
 *   opens empty.
 * - Fires ri:header-menus on document once both are in place; ri-hv4.js and ri-mobile-nav.js wire up then.
 * - Two failed tries at this address fall back to the homepage's copy, so the menus still work.
 */
(function () {
  var panelsWrap = document.querySelector('[data-hv4-panels][data-ri-menus-late]');
  var drawerBox = document.querySelector('.menu-drawer__inner-container[data-ri-menus-late]');
  if (!panelsWrap && !drawerBox) return;

  var state = (window.RIHeaderMenus = { ready: false });
  var pending = null;

  function sectionUrl(path) {
    var params = new URLSearchParams(window.location.search);
    var query = new URLSearchParams();
    /* Only the view is kept (Singles is /collections/all?view=singles); filters, sort, page, and search
       words would make the server redo that work for a menu that does not use it. */
    if (!path && params.get('view')) query.set('view', params.get('view'));
    query.set('section_id', 'ri-header-menus');
    return (path || window.location.pathname) + '?' + query.toString();
  }

  function fetchMenus(path) {
    /* A 404 page still renders the section, so the status code is not checked; the markup is. */
    return fetch(sectionUrl(path), { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var late = doc.querySelector('[data-ri-menus-late]');
        if (!late) throw new Error('Header menus missing from the response');
        return late;
      });
  }

  function load() {
    if (state.ready) return Promise.resolve();
    if (pending) return pending;
    pending = fetchMenus()
      .catch(function () {
        return fetchMenus();
      })
      .catch(function () {
        /* Last resort: the homepage's copy. Same menus, only without this page's "you are here" marks. */
        return fetchMenus('/');
      })
      .then(function (late) {
        var panels = late.querySelector('[data-ri-menus-panels]');
        var mnav = late.querySelector('[data-ri-menus-mnav]');
        if (panelsWrap && panels) panelsWrap.innerHTML = panels.innerHTML;
        if (drawerBox && mnav) drawerBox.innerHTML = mnav.innerHTML;
        state.ready = true;
        document.dispatchEvent(new CustomEvent('ri:header-menus'));
      })
      .catch(function () {
        /* Try again the next time a menu is reached for. */
        pending = null;
      });
    return pending;
  }
  state.load = load;

  function loadWhenIdle() {
    var idle =
      window.requestIdleCallback ||
      function (cb) {
        return window.setTimeout(cb, 200);
      };
    idle(load, { timeout: 1000 });
  }
  if (document.readyState === 'complete') loadWhenIdle();
  else window.addEventListener('load', loadWhenIdle, { once: true });

  document.addEventListener('ri:header-menus-need', load);

  var bar = document.querySelector('.hv4-bar');
  if (bar) {
    bar.addEventListener('pointerover', load, { once: true });
    bar.addEventListener('focusin', load, { once: true });
  }

  var summary = document.querySelector('#Details-menu-drawer-container > summary');
  if (summary && drawerBox) {
    summary.addEventListener('pointerdown', load, { once: true });
    /* Capture on document runs before Dawn's drawer handler on the summary; hold the tap until the menu is in. */
    var waiting = false;
    document.addEventListener(
      'click',
      function (event) {
        if (state.ready || event.target.closest('#Details-menu-drawer-container > summary') !== summary) return;
        event.preventDefault();
        event.stopPropagation();
        if (waiting) return;
        waiting = true;
        load().then(function () {
          waiting = false;
          if (state.ready) summary.click();
        });
      },
      true
    );
  }
})();
